import { MoreVert } from "@mui/icons-material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Box, Collapse, IconButton, TableCell, TableRow } from "@mui/material";
import { Fragment, useState } from "react";

import { SETTLEMENT_STYLES } from "../../style/styles";

import SettlementPaymentsDropdownMenu from "./SettlementPaymentsDropdownMenu";
import SettlementPaymentsRowDetails from "./SettlementPaymentsRowDetails";

export default function SettlementPaymentsListItem({
  data,
  paymentTypeDisplayMap,
  onEdit,
  canEdit = false,
}) {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const showActions = canEdit;
  const menuOpen = Boolean(anchorEl);

  return (
    <Fragment>
      <TableRow hover sx={SETTLEMENT_STYLES.tableRowUnsetBorder}>
        <TableCell align="center">
          <IconButton size="small" onClick={() => setOpen((prev) => !prev)}>
            {open ? (
              <KeyboardArrowUpIcon sx={SETTLEMENT_STYLES.moreIcon} />
            ) : (
              <KeyboardArrowDownIcon sx={SETTLEMENT_STYLES.moreIcon} />
            )}
          </IconButton>
        </TableCell>
        <TableCell>
          {paymentTypeDisplayMap[data.checkType ?? data.check_type] ??
            data.checkType ??
            data.check_type ??
            "N/A"}
        </TableCell>
        <TableCell>{data.paidBy?.name ?? data.paid_by?.name ?? "Unknown"}</TableCell>
        <TableCell>{data.paidTo?.name ?? data.paid_to?.name ?? "Unknown"}</TableCell>
        {showActions ? (
          <TableCell align="right">
            <div className="flex items-center justify-end">
              <IconButton size="small" onClick={(event) => setAnchorEl(event.currentTarget)}>
                <MoreVert sx={SETTLEMENT_STYLES.moreIcon} />
              </IconButton>
            </div>
            <SettlementPaymentsDropdownMenu
              anchorEl={anchorEl}
              open={menuOpen}
              onClose={() => setAnchorEl(null)}
              onEdit={() => {
                onEdit(data);
                setAnchorEl(null);
              }}
              paymentId={data.id}
            />
          </TableCell>
        ) : null}
      </TableRow>
      <TableRow>
        <TableCell className="pb-0 pt-0" colSpan={showActions ? 5 : 4}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box className="px-2 py-3">
              <SettlementPaymentsRowDetails payment={data} />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  );
}
